import VisitsService from '@/services/VisitsService';

export default {
  namespaced: true,
  state: {
    call: null,
  },
  getters: {},
  mutations: {
    SET_CALL(state, call) {
      state.call = call;
    },
  },
  actions: {
    getCall({ dispatch, state }, id) {
      if (state.call) {
        return state.call;
      }
      return dispatch('refreshCall', id);
    },
    refreshCall({ commit }, id) {
      return VisitsService.getVisit(id).then(res => {
        commit('SET_CALL', res.data);
      }).catch(err => err);
    },
  },
};
